module.exports = __webpack_public_path__ + "f23a0c6e02b51aeb528a7544f5c8b813.svg";